/**
 * Push-Abo automatisch abgleichen (App-Start, Rückkehr in die App).
 * Browser/iOS verwerfen Abos gelegentlich, oder der Server löscht sie nach einem 410 – ohne Abgleich
 * zeigte die App „aktiv“, es kam aber nichts an und der Spieler musste täglich neu aktivieren.
 */
import apiClient from './api';

let running = false;
let lastRun = 0;

function keyToBytes(base64: string): ArrayBuffer {
  const padding = '='.repeat((4 - (base64.length % 4)) % 4);
  const raw = atob((base64 + padding).replace(/-/g, '+').replace(/_/g, '/'));
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out.buffer as ArrayBuffer;
}

export async function syncPushSubscription(force = false): Promise<void> {
  if (running || !('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) return;
  if (Notification.permission !== 'granted' || !apiClient.getToken()) return;
  if (!force && Date.now() - lastRun < 10 * 60_000) return;
  running = true;
  lastRun = Date.now();
  try {
    const reg = await navigator.serviceWorker.ready;
    let sub = await reg.pushManager.getSubscription();

    if (sub) {
      const st = await apiClient.get<{ known?: boolean }>('/push/status', { params: { endpoint: sub.endpoint } });
      if (st.data?.known) return; // alles in Ordnung
      // Server kennt das Abo nicht mehr (z. B. abgelaufen) → altes verwerfen, neu anlegen
      await sub.unsubscribe().catch(() => {});
      sub = null;
    }

    const keyRes = await apiClient.get<{ publicKey: string }>('/push/vapid-public-key');
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: keyToBytes(keyRes.data.publicKey) });
    const { endpoint, keys } = sub.toJSON() as any;
    await apiClient.post('/push/subscribe', { endpoint, keys });
  } catch (err: any) {
    try {
      fetch('/api/client-errors', { method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
        body: JSON.stringify({ message: `Push-Abgleich fehlgeschlagen: ${err?.name ?? 'Error'}: ${err?.message ?? err}`, source: 'pushSync', stack: '', url: location.href }) }).catch(() => {});
    } catch { /* ignorieren */ }
    lastRun = Date.now() - 9 * 60_000; // nach 1 Minute erneut versuchen
  } finally {
    running = false;
  }
}
